import { render, staticRenderFns } from "./subject-modal.vue?vue&type=template&id=206d9299"
import script from "./subject-modal.vue?vue&type=script&lang=js"
export * from "./subject-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports